import Button from '@/common/components/Button'
import { priceSurveyStatusStrategy } from '@/common/constants/priceSurveyStatusOptions'
import { dateTransformer } from '@/common/utils/dateTransformer'
import { truncateText } from '@/common/utils/formatters'
import {
  CompanyPriceSurveyData,
  CompanyPriceSurveysTableItem,
} from '@/features/privateCompanies/types/companyPriceSurvey.type'
import { ArrowBigRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

export class CompanyPriceSurveyTransformer {
  static tableTransformer({
    companyId,
    operationKlassToCheckPermission,
  }: {
    companyId: string
    operationKlassToCheckPermission?: string
  }): (events: CompanyPriceSurveyData[]) => CompanyPriceSurveysTableItem[] {
    return (companyPriceSurveys: CompanyPriceSurveyData[]) => {
      return companyPriceSurveys.map((companyPriceSurvey) => {
        const tooltipId = `${companyPriceSurvey.id}-cities-tooltip`
        const cities = companyPriceSurvey.cities.map((city) => city.display_name).join(', ')

        return {
          ...companyPriceSurvey,
          status: priceSurveyStatusStrategy[companyPriceSurvey.status as keyof typeof priceSurveyStatusStrategy],
          city: (
            <>
              <p data-tooltip-id={tooltipId} className='max-w-lg'>{truncateText(cities, 64)}</p>
              {cities.length > 64 && (
                <Tooltip id={tooltipId} className="z-50 max-w-96 text-wrap">
                  {cities}
                </Tooltip>
              )}
            </>
          ),
          survey_conducted_at: dateTransformer(companyPriceSurvey.survey_conducted_at),
          actions: (
            <Link to={`/companies/${companyId}/price-survey/${companyPriceSurvey.id}`}>
              <Button
                name="access_company_price_survey"
                className="bg-transparent hover:bg-transparent p-0"
                operationKlassToCheckPermission={operationKlassToCheckPermission}
              >
                <ArrowBigRight />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
